import * as React from 'react';
import { useSelector } from 'react-redux';
import { CallbackButton } from '../../components/CallbackButton';
import { selectAnalyticsUser, selectGaLabel } from '../../selectors/analytics';
import { selectBuilderId, selectCallbackPhone, selectNewbuildingId, selectTimezone } from '../../selectors/newbuilding';
import { selectUserPhone } from '../../selectors/user';
import { NewbuildingCallbackWidgetContext } from '../NewbuildingCallbackWidgetProvider';

export const CallbackButtonContainer: React.FC = () => {
  const agentPhone = useSelector(selectCallbackPhone);
  const timezoneOffset = useSelector(selectTimezone);
  const userPhoneNumber = useSelector(selectUserPhone);
  const gaLabel = useSelector(selectGaLabel);
  const user = useSelector(selectAnalyticsUser);
  const newbuildingId = useSelector(selectNewbuildingId);
  const builderRealtyUserId = useSelector(selectBuilderId);
  const [loading, setLoading] = React.useState(false);

  const openWidget = React.useContext(NewbuildingCallbackWidgetContext);

  const openWidgetCallback = React.useCallback(async () => {
    if (!agentPhone || !builderRealtyUserId) {
      return;
    }

    setLoading(true);

    await openWidget({
      agentPhone,
      timezoneOffset,
      userPhoneNumber,
      builderRealtyUserId,
      newbuildingId,
      trackingParams: {
        category: 'BuildingProgressJK',
        opener: 'blockJK',
        gaLabel,
        user,
      },
    });

    setLoading(false);
  }, [openWidget, agentPhone, builderRealtyUserId, gaLabel, timezoneOffset, userPhoneNumber, user, newbuildingId]);

  if (!agentPhone || !builderRealtyUserId) {
    return null;
  }

  return <CallbackButton onClick={openWidgetCallback} loading={loading} />;
};
